export default __webpack_public_path__ + "Facebook_Logo_Primary.71609df8f049c72aaad74aeb8cbe028d.png";